module.exports = __webpack_public_path__ + "static/media/Setubal.57fc57ec.svg";